import * as React from "react";
import {
  alpha,
  Box,
  Button,
  CardMedia,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { CalendarInfo, CalendarItem } from "./Calendar";
import { DataContext } from "./Context/ContextWrapper";
import { pamedg } from "../../../networking";

export default function OptionsMenu(props: {
  calendarInfo: CalendarInfo;
  data: any;
  oggettoNota: any;
  setShowOptionNoteGiornaliere: React.Dispatch<React.SetStateAction<boolean>>;
  setShowOptionOrarioGiornaliero: React.Dispatch<React.SetStateAction<boolean>>;
  setShowOptionCancellazioneOrarioGiornaliero: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setShowOptionInserireIndisponibilita: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setDataGiornoSelezionato: React.Dispatch<React.SetStateAction<boolean>>;
  setOggettoNotaSelezionato: React.Dispatch<React.SetStateAction<any>>;
  setShowOrarioDettaglio: ((value: boolean) => void) | undefined;
  setMessage: (value: string) => void;
  setSeverity: React.Dispatch<
    React.SetStateAction<"success" | "error" | "info" | "warning">
  >;
  setShowAllert: React.Dispatch<React.SetStateAction<boolean>>;
  setFn: React.Dispatch<React.SetStateAction<(() => void) | null>>;
}) {
  const context = React.useContext(DataContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // funzione unica gestione eventi richiamati al click della opzione di gestione orario giornaliero
  const onClickGestioneOrarioGiornaliero = () => {
    // NOTA BENE: accesso al context che salva tutto il calendarData richiamabile poi a livello superiore da AppointmentManagement
    // poiché la componente del dettaglio orario giornaliero è posizionata prima
    context?.setDataCalendarSelezionato({
      ...props.calendarInfo,
      dataSelezionata: props.data,
    });
    props.setShowOrarioDettaglio?.(true);
  };

  const deleteRequestGestioneGiornaliera = async () => {
    try {
      const payloadRead = {
        crud: "R",
        aziendaPrenotazione:
          context?.dataCalendarSelezionato?.aziendaPrenotazione ?? "",
        CODMEDINT: context?.dataCalendarSelezionato?.codiceMedico ?? "",
        CODPGMEDT: context?.dataCalendarSelezionato?.agenda ?? "",
        CODTPGPRE: context?.dataCalendarSelezionato?.tipologia ?? "",
        dataIni: context?.dataCalendarSelezionato?.dataSelezionata ?? "",
        dataFin: context?.dataCalendarSelezionato?.dataSelezionata ?? "",
      };

      const responseRead = await pamedg(payloadRead);

      if (responseRead.data.esito === "OK") {
        if (responseRead?.data?.dati?.OrarioGiornaliero[0]?.IDPAMEDG) {
          const payloadDelete = {
            crud: "D",
            aziendaPrenotazione:
              context?.dataCalendarSelezionato?.aziendaPrenotazione ?? "",
            IDPAMEDG: responseRead?.data?.dati?.OrarioGiornaliero[0]?.IDPAMEDG,
          };

          const responseDelete = await pamedg(payloadDelete);

          if (responseDelete.data.esito === "OK") {
            props.setMessage("Orario giornaliero eliminato con successo");
            props.setSeverity("success");
          } else {
            props.setMessage(
              "Errore nella cancellazione dell'orario giornaliero"
            );
            props.setSeverity("error");
          }

          console.log({ responseDelete });
        } else {
          props.setMessage(
            "Non è stato possibile recuperare alcun Orario Giornaliero associato a questa data"
          );
          props.setSeverity("info");
        }
      }
    } catch (error) {
      console.error("Errore sulla send di cancellazione", error);
    } finally {
      props.setFn(null)
    }
  };

  const onClickCancellazioneOrarioGiornaliero = () => {
    context?.setDataCalendarSelezionato({
      ...props.calendarInfo,
      dataSelezionata: props.data,
    });
    props.setFn(() => deleteRequestGestioneGiornaliera);
    props.setMessage(
      "Procedere con la cancellazione delle disponibilità di questa giornata?"
    );
    props.setSeverity("warning");
    props.setShowAllert(true);
  };

  const onClickInserisciIndisponibilita = () => {
    console.log(props.data);
    
    props.setDataGiornoSelezionato(props.data);
    props.setShowOptionInserireIndisponibilita(true);
  };

  // Array di opzioni
  const options = [
    {
      label: "Orario giornaliero",
      onClick: onClickGestioneOrarioGiornaliero,
    },
    {
      label: "Canc. orario giornaliero",
      onClick: onClickCancellazioneOrarioGiornaliero,
    },
    {
      label: "Ins. Indisponibilità",
      onClick: onClickInserisciIndisponibilita,
    },
    {
      label: "Note giornaliere",
      onClick: () => {
        props.setOggettoNotaSelezionato(props.oggettoNota);
        props.setDataGiornoSelezionato(props.data);
        props.setShowOptionNoteGiornaliere(true);
      },
    },
  ];

  return (
    <div>
      <Tooltip title="Menu">
        <IconButton
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          size={"small"}
          sx={{
            height: "24",
            width: "24",
            padding: 0.2,
          }}
        >
          <CardMedia
            component="svg"
            sx={{ height: 17, width: 17 }}
            {...{
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 17 17",
            }}
          >
            <path
              d="M7.28565 4.25C7.28565 4.05222 7.34429 3.85888 7.45418 3.69443C7.56406 3.52998 7.72024 3.40181 7.90296 3.32612C8.08569 3.25043 8.28675 3.23063 8.48074 3.26922C8.67472 3.3078 8.8529 3.40304 8.99275 3.54289C9.1326 3.68275 9.22785 3.86093 9.26643 4.05491C9.30502 4.24889 9.28521 4.44996 9.20952 4.63268C9.13384 4.81541 9.00566 4.97159 8.84122 5.08147C8.67677 5.19135 8.48343 5.25 8.28565 5.25C8.02043 5.25 7.76607 5.14464 7.57854 4.95711C7.391 4.76957 7.28565 4.51522 7.28565 4.25ZM8.28565 7.5C8.08786 7.5 7.89452 7.55865 7.73007 7.66853C7.56563 7.77841 7.43745 7.93459 7.36177 8.11732C7.28608 8.30004 7.26627 8.50111 7.30486 8.69509C7.34344 8.88907 7.43869 9.06725 7.57854 9.20711C7.71839 9.34696 7.89657 9.4422 8.09055 9.48079C8.28454 9.51937 8.4856 9.49957 8.66833 9.42388C8.85106 9.34819 9.00723 9.22002 9.11711 9.05557C9.227 8.89112 9.28565 8.69778 9.28565 8.5C9.28565 8.23478 9.18029 7.98043 8.99275 7.79289C8.80522 7.60536 8.55086 7.5 8.28565 7.5ZM8.28565 11.75C8.08786 11.75 7.89452 11.8087 7.73007 11.9185C7.56563 12.0284 7.43745 12.1846 7.36177 12.3673C7.28608 12.55 7.26627 12.7511 7.30486 12.9451C7.34344 13.1391 7.43869 13.3173 7.57854 13.4571C7.71839 13.597 7.89657 13.6922 8.09055 13.7308C8.28454 13.7694 8.4856 13.7496 8.66833 13.6739C8.85106 13.5982 9.00723 13.47 9.11711 13.3056C9.227 13.1411 9.28565 12.9478 9.28565 12.75C9.28565 12.4848 9.18029 12.2304 8.99275 12.0429C8.80522 11.8554 8.55086 11.75 8.28565 11.75Z"
              fill="black"
            />
          </CardMedia>
        </IconButton>
      </Tooltip>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <Box padding={1}>
          {options.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => {
                option.onClick();
                handleClose();
              }}
              sx={{
                ":hover": {
                  backgroundColor: alpha("#8DBEE9", 0.3),
                  borderRadius: 1,
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  fontFamily: "Rubik",
                  color: "rgba(0, 0, 0, 0.60)",
                  fontSize: 14,
                  fontStyle: "normal",
                  letterSpacing: "-0.14px",
                }}
              >
                {option.label}
              </Typography>
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </div>
  );
}
